var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
export class Address {
  constructor(_data) {
    /**
     */
    __publicField(this, "City");
    /**
     */
    __publicField(this, "Province");
    /**
     */
    __publicField(this, "Street");
    /**
     */
    __publicField(this, "StreetNumber");
    /**
     */
    __publicField(this, "Zip");
    /**
     * Adds support for polymorphism. The discriminator is the schema property
     * name that is used to differentiate between other schema that inherit this
     * schema.
     *
     * @protected
     * @type {string}
     * @memberof Address
     */
    __publicField(this, "$type", "V1.Primitives.Address");
    if (_data) {
      for (const property in _data) {
        if (_data.hasOwnProperty(property)) {
          this[property] = _data[property];
        }
      }
    }
  }
  /**
   * Initializes a new model instance.
   */
  init(_data) {
    if (_data) {
      this.City = _data["City"];
      this.Province = _data["Province"];
      this.Street = _data["Street"];
      this.StreetNumber = _data["StreetNumber"];
      this.Zip = _data["Zip"];
    }
    return this;
  }
  toJSON(_data) {
    _data = typeof _data === "object" ? _data : {};
    _data["City"] = this.City;
    _data["Province"] = this.Province;
    _data["Street"] = this.Street;
    _data["StreetNumber"] = this.StreetNumber;
    _data["Zip"] = this.Zip;
    return _data;
  }
}
